import React, { useEffect } from 'react';

import { WorkflowEntity } from '../../workflow/Workflow.interface';
import { useFindWorkflowVersionByEntity } from '../../workflow/Workflow.hooks';
import WorkflowStatusSelector, {
  WorkflowStatusSelectorProps
} from '../../workflow/components/WorkflowStatusSelector';

export type SupplierStatusFilterProps = Pick<
  WorkflowStatusSelectorProps,
  'value' | 'onChange'
>;

const SupplierStatusFilter: React.FC<SupplierStatusFilterProps> = (
  props: SupplierStatusFilterProps
) => {
  const {
    workflowVersion,
    isLoading,
    loadingError,
    findWorkflowVersion
  } = useFindWorkflowVersionByEntity(WorkflowEntity.Supplier);

  useEffect(() => {
    findWorkflowVersion();
  }, [findWorkflowVersion]);

  return (
    <WorkflowStatusSelector
      {...props}
      error={loadingError}
      isLoading={isLoading}
      workflowVersion={workflowVersion}
      textFieldProps={{ label: undefined, placeholder: 'Select Status' }}
    />
  );
};

export default SupplierStatusFilter;
